import script from "./kurvHover.vue?vue&type=script&setup=true&lang=js"
export * from "./kurvHover.vue?vue&type=script&setup=true&lang=js"

import "./kurvHover.vue?vue&type=style&index=0&id=6a049e96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a049e96"]])

export default __exports__